import React from "react";
import Modal from "../Modal/Modal";
import { useModalConfirmContext } from "./ModalConfirmContext";
import styled from "styled-components";
import FormButton from "../FormCustom2/Button";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ModalConfirm = () => {
  const { modalProps, handleClose, T } = useModalConfirmContext();

  if (!modalProps?.open) return null;

  const {
    title,
    message,
    icon,
    confirmButtonProps = {},
    cancelButtonProps = {},
    confirmButtonTitle = T("Confirm"),
    cancelButtonTitle = T("Cancel"),
    width = "600px",
    padding,
  } = modalProps;

  return (
    <Modal onClose={() => handleClose(false)}>
      <Modal.ModalBg2 onClose={() => handleClose(false)} />
      <Modal.Container2 width={width} padding={padding} onClose={() => handleClose(false)}>
        <ContentWaper>
          <div className="text-center font-bold text-[24px] lg:text-[28px]">
            {title}
          </div>
          <div className="mt-[10px] lg:mt-[10px]">
            <div>
              <div className="mt-[15px] lg:mt-[20px] flex justify-center items-center">
                {icon}
              </div>
              <div className="mt-[15px] lg:mt-[20px] flex justify-center text-center items-center text-[14px] text-black text-base leading-[26px]">
                {message}
              </div>
              <div className="my-[32px] hidden md:block" />
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap md:flex-nowrap justify-center items-center gap-[20px]">
                <FormButton
                  width={160}
                  className={"black2 w-full md:w-auto min-w-[160px]"}
                  onClick={() => handleClose(false)}
                  {...cancelButtonProps}
                >
                  {cancelButtonTitle}
                </FormButton>
                <FormButton
                  width={160}
                  className={"primary2 w-full md:w-auto"}
                  onClick={() => handleClose(true)}
                  {...confirmButtonProps}
                >
                 {confirmButtonTitle}
                </FormButton>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  )
};

export default ModalConfirm;
